module.exports = __webpack_public_path__ + "img/avatar.4aae295a.png";